import React, { Component } from "react";
import Spinner from "js/react/components/Spinner";

/**
 * This component is intended to handle rendering JSX after an async event is finished.
 * @param load Required prop to handle some async activity before renderChildren is called.
 * @param renderChildren Renders JSX after async load function is finished.
 */
export default class LoadableAsync extends Component {
    state = {
        isLoading: true
    }

    async componentDidMount() {
        const { load } = this.props;
        if (load) {
            await load();
            this.setState({ isLoading: false });
        } else {
            throw Error("load prop must be passed for LoadableAsync component");
        }
    }

    render() {
        let { isLoading, renderChildren } = this.props;

        if (isLoading) {
            return <div style={{ minHeight: 100 }}><Spinner /></div>;
        } else {
            return renderChildren() || null;
        }
    }
}
